<template>
    <div>
        <div class="calendarHolder">
            <fullcalendar :events="events" @dayClick="addEvent" @eventClick="viewEvent"></fullcalendar>
        </div>

        <b-modal id="addEventModal"
             :title="'Add Entry - ' + readableDate(currentDay)"
             size="md"
             scrollable
             button-size="sm"
             hide-footer
             centered>
            <b-row>
                <b-col>
                    <b-form-group label="Name" v-if="canAddAll">
                        <b-form-radio-group
                            v-model="username"
                            :options="[ { text: 'All', value: 'All' }, { text: $auth.user.nickname, value: $auth.user.nickname }]"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-input-group size="sm">
                        <b-input placeholder="Reason" v-model="reason" ref="reasonInput" @keyup.enter="newEvent"></b-input>
                        <b-button @click="newEvent" size="sm">Add Entry</b-button>
                    </b-input-group>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal id="viewEventModal"
             :title="readableDate(event.start)"
             size="md"
             scrollable
             button-size="sm"
             hide-footer
             centered>
             <p><em>{{ event.title }}</em></p>
             <b-button variant="danger" @click="removeEvent(event._id)" v-if="event.username === $auth.user.nickname || canRemove">Remove</b-button>
        </b-modal>
    </div>
</template>

<script>
    import fullcalendar from "vue-fullcalendar";
    import calendarApi from "../../api/calendar";
    import moment from "moment";
    import utils from "../../mixins/utils";

    export default {
        name: "Calendar",
        mixins: [ calendarApi, utils ],
        components: {
			fullcalendar,
		},
        data() {
            return {
                event: {},
                currentDay: null,
                reason: null,
                events: [],
                username: null,
            }
        },
        async created() {
            await this.fetchEvents();
        },
        computed: {
            canAddAll() {
                return this.$auth.user.nickname === 'tim' || this.$auth.user.nickname === 'edward' || this.$auth.user.nickname === 'craig';
            },
            canRemove() {
                return this.$auth.user.nickname === 'tim' || this.$auth.user.nickname === 'edward' || this.$auth.user.nickname === 'craig';
            }
        },
        methods: {
            async fetchEvents(from, to) {
                if (!from) {
                    from = moment().subtract(1, 'year').startOf('month').format('YYYY-MM-DD').toString();
                }

                if (!to) {
                    to = moment().add(1, 'year').endOf('month').format('YYYY-MM-DD').toString();
                }

                const resp = await this.getEvents(from, to);
                
                this.events = resp.map(event => {
                    event.title = `${event.username} - ${event.title}`;

                    return event;
                });
            },
            addEvent(day) {
                this.currentDay = day;
                this.username = null;
                this.$bvModal.show('addEventModal');

                this.$nextTick(() => {
                    this.$refs.reasonInput.$el.focus();
                });
            },
            async newEvent() {
                try {
                    let event = {
                        title: this.reason,
                        start: this.currentDay,
                        end: this.currentDay,
                        username: this.username || this.$auth.user.nickname,
                    }

                    const resp = await this.createEvent(event);
                    resp.title = `${event.username} - ${event.title}`;

                    this.events.push(resp);
                } catch (err) {
                    this.showError(err);
                }

                this.$bvModal.hide('addEventModal');
            },
            async viewEvent(event) {
                this.event = event;
                this.$bvModal.show('viewEventModal');
            },
            async removeEvent(id) {
                try {
                    await this.deleteEvent(id);
                    await this.fetchEvents();
                } catch (err) {
                    this.showError(err);
                }

                this.$bvModal.hide('viewEventModal');
            },
            readableDate(day) {
                if (!day) {
                    return ``;
                }

                return moment(day).format('MMMM Do, YYYY').toString();
            },
            formatDate(day) {
                if (!day) {
                    return ``;
                }

                return moment(day).format('YYYY-MM-DD').toString();
            }
        },
    }
</script>

<style>
    .dates-bg {
        width: 100%;
        height: 100%;
    }

    .calendarHolder {
        height: 750px;
    }
</style>